import {useEffect, useState} from 'react';
import MainPanelHeader from "../../../layouts/mainPanelHeader";
import WalletModal from "../../../component/global/WalletModal";
import {get} from "../../../controlers/global/ConfigRequest";
import {GET_USER_MONEY_COINS_UR} from "../../../helperData/ApiAddress";
import PanelRightContent from "../../../layouts/mainPanel/PanelRightContent";
import PanelLeftContent from "../../../layouts/mainPanel/PanelLeftContent";
import SmallCoin from "../../../asset/image/small-coin.png";
import {ReactComponent as OtherDots} from "../../../asset/icons/otherDotsIcon.svg";
import {CartesianGrid, Line, LineChart, ResponsiveContainer, XAxis, YAxis} from "recharts";
import {ReactComponent as WalletIcon} from "../../../asset/icons/walletIcon.svg";
import Exchange from "../../Rating/Exchange";

const data = [
  {
    name: "مهر",
    uv: 20,
    pv: 80,
  },
  {
    name: "آبان",
    uv: 60,
    pv: 60,
  },
  {
    name: "آذر",
    uv: 40,
    pv: 50,
  },
  {
    name: "دی",
    uv: 80,
    pv: 7,
  },
  {
    name: "بهمن",
    uv: 60,
    pv: 10,
  },
];

function UserExchange(props) {
  const [coins, setCoins] = useState();
  const [money, setMoney] = useState();
  const [walletModalState, setWalletModalState] = useState(false);

  useEffect(() => {
    // getUserMoneyCoins();
    get(GET_USER_MONEY_COINS_UR).then((r) => {
      setCoins(r[1]?.balance);
      setMoney(r[0]?.balance);
    });
  }, []);

  return (
    <div
      id="user-exchange"
      className="main_panel_box user-profile exchange-container"
    >
      <MainPanelHeader/>
      <WalletModal
        showModal={walletModalState}
        closeModal={(_) => setWalletModalState(false)}
        money={money}
        coins={coins}
      />
      <div className="user-profile_content main_panel_content">
        <PanelRightContent>
          <Exchange isUserPanel/>
        </PanelRightContent>
        <PanelLeftContent>
          <div className="left-section">
            <div className="chart-title">
              <img src={SmallCoin} alt="coin"/>{" "}
              <span>باشگاه مشتریان</span>
              <button className="more-dots ratings-btn">
                <OtherDots/>
              </button>
            </div>
            <div className="charts">
              <ResponsiveContainer width="100%" height="100%">
                <LineChart
                  width={500}
                  height={300}
                  data={data}
                  margin={{
                    top: 10,
                    right: 0,
                    left: -40,
                    bottom: -10,
                  }}
                >
                  <CartesianGrid strokeDasharray="3 3"/>
                  <XAxis dataKey="name"/>
                  <YAxis tickMargin={15}/>
                  <Line
                    type="monotone"
                    dataKey="uv"
                    stroke="#FEB730"
                    strokeWidth={2}
                    activeDot={{r: 8}}
                  />
                </LineChart>
              </ResponsiveContainer>
            </div>
          </div>
          <div className="left-section">
            <div className="chart-title">
              <img src={SmallCoin} alt="coin"/>{" "}
              <span>باشگاه مشتریان</span>
              <button className="more-dots ratings-btn">
                <OtherDots/>
              </button>
            </div>
            <div className="charts">
              <ResponsiveContainer width="100%" height="100%">
                <LineChart
                  width={500}
                  height={300}
                  data={data}
                  margin={{
                    top: 10,
                    right: 0,
                    left: -40,
                    bottom: -10,
                  }}
                >
                  <CartesianGrid strokeDasharray="3 3"/>
                  <XAxis dataKey="name"/>
                  <YAxis tickMargin={15}/>
                  <Line
                    type="monotone"
                    dataKey="uv"
                    stroke="#FEB730"
                    strokeWidth={2}
                    activeDot={{r: 8}}
                  />
                </LineChart>
              </ResponsiveContainer>
            </div>
          </div>
          <div className="left-section">
            <div className="chart-title">
              <WalletIcon/>
              <div>کیف پول</div>
            </div>
            <div className="wallet">
              <div>موجودی کیف پول</div>
              <div>
                تومان<span>{money || "-"}</span>
              </div>
              <div className="btn-group">
                <button
                  className=" blue"
                  onClick={(_) => setWalletModalState(true)}
                >
                  شارژ کیف پول
                </button>
              </div>
            </div>
          </div>
        </PanelLeftContent>
      </div>
    </div>
  );
}

export default UserExchange;
